import XResizableTextarea from "./common/XResizableTextarea";
import CaseFileUpload from "./common/CaseFileUpload";
import useCertifiedLifecareCompany from "../hooks/useCertifiedLifecareCompany";
import HeadshotViewer from "./HeadshotViewer";
import { cardTitleClasses } from "./common/formClasses";

const HeadshotUploadForm = ({
    formik,
    handleFileSelection,
    isUploading
}) => {
    const isCertifiedLifecareCompany = useCertifiedLifecareCompany();
    if (!isCertifiedLifecareCompany) return null;

    return (
        <>

            <div className="col-md-6">
                <div className={`title flex justify-between min-h-10 ${cardTitleClasses}`}>
                    <h2>Headshot Information</h2>
                    <HeadshotViewer
                        headshot={formik.values.headshot}
                    />
                </div>
                    <CaseFileUpload
                        label="Headshot"
                        uploadButtonText="Upload Headshot"
                        accept="image/*"
                        multiple={false}
                        files={formik.values.headshot ? [formik.values.headshot] : []}
                        onFileSelect={handleFileSelection}
                        onRemove={() => formik.setFieldValue("headshot", null)}
                        isLoading={isUploading}
                    />
                <div className="form-group">
                    <XResizableTextarea
                        name="blurbText"
                        label="Personal Introduction"
                        placeholder="Enter a personal introduction for law firms on ARCHES"
                        {...formik.getFieldProps("blurbText")}
                    />
                </div>
            </div>
        </>
    )
}

export default HeadshotUploadForm